import {forwardRef, ReactNode} from "react";
import {Box, BoxProps} from "@mui/material";
import useIsMobile from "../../helpers/useIsMobile";

interface PageProps extends BoxProps {
  children: ReactNode;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({children, title = "", sx, ...other}, ref) => {
  const isMobile = useIsMobile();

  return (
    // @ts-ignore
    <Box ref={ref} sx={{py: isMobile ? 2.5 : 5.5, px: isMobile ? 2.5 : 5.5, ...sx}} {...other}>
      {children}
    </Box>
  );
});

export default Page;
